import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import UOMInfo from "./components/UOMInfo";
import { formRender, initialValues, uomValidations } from "./uom-schema";
import { editUOM } from "services/data.internal.service";
import { SaveButton } from "ui-components/Form";
import { useLocation } from "react-router-dom";
import { getUOM } from "services/data.internal.service";

function EditUOM() {
  const location = useLocation();
  const { uomid } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["uom", { uomid }],
    queryFn: () => getUOM({ uomid }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });
  const editUOMMutation = useMutation(editUOM, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(uomValidations),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    editUOMMutation.mutate(data, {onSuccess: () => queryClient.invalidateQueries(["uom"])});
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <UOMInfo {...infoProps} />
        <SaveButton label="save" disabled={!isDirty} url="/setup/uom" />
      </form>
    </Layout>
  );
}

export default EditUOM;
